// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-bundles-about-index-js": () => import("./../../../src/bundles/about/index.js" /* webpackChunkName: "component---src-bundles-about-index-js" */),
  "component---src-bundles-about-product-index-js": () => import("./../../../src/bundles/about/product/index.js" /* webpackChunkName: "component---src-bundles-about-product-index-js" */),
  "component---src-bundles-about-team-index-js": () => import("./../../../src/bundles/about/team/index.js" /* webpackChunkName: "component---src-bundles-about-team-index-js" */)
}

